import { getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";

import { apiErrorHandler } from "../utilities/utitlityFunctions";
import { firebaseConfig } from "../utilities/constanst";
import {
  fetchSaccoMemberByEmail,
  invalidateSaccoMemberCache,
} from "./saccoMemberService";
import { appNavigate } from "./navigationService";
import {
  hasSaccoMemberProfile,
  isPublicAuthPath,
  resolvePostLoginPath,
  SACCO_MEMBER_ONBOARDING_PATH,
} from "./sessionAccess";
import { normalizePath } from "./rbacService";

const firebaseApp = initializeApp(firebaseConfig);
export const app = firebaseApp;
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);

export function AppInitialization(setUser) {
  try {
    return onAuthStateChanged(auth, async function (user) {
      if (user) {
        const saccoUser = await fetchSaccoMemberByEmail(db, user.email);

        const currentUser = {
          displayName: user.displayName,
          name: user.email,
          firstName: saccoUser.firstName ?? "",
          lastName: saccoUser.lastName,
          emailVerified: user.emailVerified,
          photoURL: user.photoURL,
          isAnonymous: user.isAnonymous,
          uid: user.uid,
          provideData: user.providerData,
        };

        setUser({ currentUser, saccoUser, authResolved: true });

        const path = normalizePath(window.location.pathname);
        if (path === "/login" || path === "/register") {
          if (!hasSaccoMemberProfile(saccoUser)) {
            appNavigate(SACCO_MEMBER_ONBOARDING_PATH, { replace: true });
          } else {
            appNavigate(resolvePostLoginPath(saccoUser), { replace: true });
          }
        } else if (
          !hasSaccoMemberProfile(saccoUser) &&
          path !== SACCO_MEMBER_ONBOARDING_PATH &&
          !isPublicAuthPath(path)
        ) {
          appNavigate(SACCO_MEMBER_ONBOARDING_PATH, { replace: true });
        }
        return;
      }

      invalidateSaccoMemberCache();
      setUser({
        currentUser: null,
        saccoUser: null,
        authResolved: true,
      });
    });
  } catch (error) {
    apiErrorHandler(error);
  }
  return () => {};
}
